import './AuthPassword.sass';

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRoute, useRouter } from 'react-router5';

import { Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { authActions } from '$store/auth';
import { getAccounts } from '$utils';
import { FEED } from '$shared/constants/pages';

export const AuthPassword: FC = () => {
  const router = useRouter();
  const t = useTranslator();
  const route = useRoute();
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');

  const userId = useMemo(() => {
    const hash = route?.route.params.hash;
    if (!hash) {
      return false;
    }
    return parseInt(hash, 16) - 1000000000;
  }, [route]);

  useEffect(() => {
    if (userId > 0 && !window.isWebApp) {
      const accounts = getAccounts();
      for (let account of accounts) {
        if (account.id === userId) {
          dispatch(authActions.changeAccount(account.id));
          router.navigate(FEED);
          break;
        }
      }
    }
  }, [userId]);

  const handleChangePassword = useCallback(
    (e: React.ChangeEvent) => {
      const target = e.target as HTMLInputElement;
      setPassword(target.value);
    },
    [setPassword],
  );

  const handleSubmit = useCallback(() => {
    if (!!password && userId) {
      dispatch(
        authActions.authWithPassword({
          userId,
          password,
        }),
      );
    }
  }, [password, userId, route]);

  return (
    <>
      <Header>{t('auth_with_pass_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem title={t('auth_with_pass_password')}>
            <Input type="password" value={password} onChange={handleChangePassword} />
          </FormItem>
          <FormItem>
            <Button onClick={handleSubmit}>{t('auth_with_pass_auth_button')}</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
